import { cn } from "@/lib/utils"

import ring from "./border-raster.webp"

// Slice in asset pixels: the asset is the Figma 2x export, so 24 = the 12-unit corner cell.
const SLICE = 24

type StoneBorderRasterProps = {
  className?: string
}

// The stroke of the Figma 2x export (684x104) with the interior keyed out, so the fill tone shows
// through, applied as a CSS 9-slice. Corners scale with --stone-cap, edges stretch along their
// axis only; being a bitmap it downsamples at DPR 1 and softens above DPR 2, but it is the export
// pixel-for-pixel at 342x52 on a 2x screen. A vector ring (feDisplacementMap or a baked wobbly
// path) was tried first and never matched the export's relief — see git history.
export function StoneBorderRaster({ className }: StoneBorderRasterProps) {
  return (
    <span
      className={cn("pointer-events-none absolute inset-0", className)}
      style={{
        border: "0 solid transparent",
        borderImage: `url("${ring.src}") ${SLICE} / var(--stone-cap) stretch`,
      }}
    />
  )
}
